import { get, post, patch } from 'axios'

export const serializeQuery = obj =>
  Object.keys(obj)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    .join('&')

const url = (id, query = {}) => {
  const str = id ? `/tickets/${id}` : '/tickets'
  return `${str}${serializeQuery(query) ? `?${serializeQuery(query)}` : ''}`
}

export const findTickets = ({ query }) =>
  get(url(undefined, query)).then(r => r.data)
export const saveTicket = ({ isAnonymous, isPositive, message }) =>
  post(url(), { isAnonymous, isPositive, message }).then(r => r.data)

export const getTicketThread = ticketId =>
  get(`${url(ticketId)}/messages`).then(r => r.data.messages)

export const markIsRead = (ticketId, isRead) => patch(url(ticketId), { isRead })

export const completeFeedback = (ticketId, closed) =>
  patch(url(ticketId), { closed })

export const rateFeedback = (ticketId, { rating }) =>
  patch(url(ticketId), { rating })

export const sendMessage = async (ticketId, { message, isAnonymous }) =>
  post(`${url(ticketId)}/messages`, {
    message,
    isAnonymous,
  })

export const setReadTicket = async (ticketId, isRead) =>
  patch(url(ticketId), { isRead })

export const loadAvailableFilters = (query = {}) =>
  get(url('filters', query)).then(r => r.data)

export default {
  findTickets,
  setReadTicket,
  getTicketThread,
  markIsRead,
  loadAvailableFilters,
  serializeQuery,
  rateFeedback,
  sendMessage,
  completeFeedback,
}
